var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { attrs: { "body-style": { padding: "32px 24px 70px" } } },
    [
      _c("div", { staticClass: "warning-header" }, [
        _c(
          "div",
          { staticClass: "warning-title" },
          [
            _c("span", [_vm._v("PayPal账户预警")]),
            _c("el-switch", {
              attrs: { value: _vm.form.status ? true : false },
              on: { change: _vm.changeStatus },
            }),
          ],
          1
        ),
        _c("div", { staticClass: "warning-tip" }, [
          _vm._v(
            "当PayPal账户满足以下条件时，将标记为预警账户，系统将提醒您留意风控风险"
          ),
        ]),
      ]),
      _vm.form.status
        ? [
            _c(
              "div",
              { staticClass: "condition-list" },
              [
                _c(
                  "el-form",
                  {
                    ref: "paypalWarningList",
                    attrs: { inline: "", model: _vm.form },
                  },
                  [
                    _vm._l(_vm.form.paypalWarningList, function (item, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "condition-item" },
                        [
                          _c("div", { staticClass: "condition-header" }, [
                            _c("span", [
                              _vm._v("预警条件" + _vm._s(index + 1)),
                            ]),
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.form.paypalWarningList.length > 1,
                                  expression:
                                    "form.paypalWarningList.length > 1",
                                },
                              ],
                              staticClass: "iconfont-el icon-a-18guanbi1",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function ($event) {
                                  return _vm.removeCondition(index)
                                },
                              },
                            }),
                          ]),
                          _c("div", { staticClass: "condition-content" }, [
                            _c(
                              "div",
                              { staticClass: "condition-title" },
                              [
                                _c("div", [_vm._v("如果符合下列")]),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      width: "100px",
                                      margin: "0 12px",
                                    },
                                    model: {
                                      value: item.type,
                                      callback: function ($$v) {
                                        _vm.$set(item, "type", $$v)
                                      },
                                      expression: "item.type",
                                    },
                                  },
                                  _vm._l(_vm.fConfig, function (f, fIndex) {
                                    return _c("el-option", {
                                      key: fIndex,
                                      attrs: { label: f.label, value: f.value },
                                    })
                                  }),
                                  1
                                ),
                                _c("div", [_vm._v("条件：")]),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "condition-rule" },
                              [
                                _vm._l(
                                  item.paypalWarningItemList,
                                  function (condition, cIndex) {
                                    return [
                                      _c(
                                        "div",
                                        {
                                          key: cIndex,
                                          staticClass: "condition-rule-item",
                                        },
                                        [
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "160px",
                                                  },
                                                  on: {
                                                    change: function (val) {
                                                      return _vm.setRuleList(
                                                        val,
                                                        index,
                                                        cIndex
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: condition.columnType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        condition,
                                                        "columnType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "condition.columnType",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.conditionList,
                                                  function (f, fIndex) {
                                                    return _c("el-option", {
                                                      key: fIndex,
                                                      attrs: {
                                                        label: f.label,
                                                        value: f.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "160px",
                                                  },
                                                  attrs: {
                                                    disabled:
                                                      !condition.columnType,
                                                  },
                                                  model: {
                                                    value: condition.matchRule,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        condition,
                                                        "matchRule",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "condition.matchRule",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.getRuleList(
                                                    condition.columnType
                                                  ),
                                                  function (f, fIndex) {
                                                    return _c("el-option", {
                                                      key: fIndex,
                                                      attrs: {
                                                        label: f.label,
                                                        value: f.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              ref:
                                                "columnValue" + index + cIndex,
                                              refInFor: true,
                                              attrs: {
                                                prop:
                                                  "paypalWarningList." +
                                                  index +
                                                  ".paypalWarningItemList." +
                                                  cIndex +
                                                  ".columnValue",
                                                rules: _vm.inputRule,
                                              },
                                            },
                                            [
                                              ![2, 3, 4].includes(
                                                condition.columnType
                                              )
                                                ? _c(
                                                    "el-select",
                                                    {
                                                      staticStyle: {
                                                        "max-width": "400px",
                                                        "min-width": "280px",
                                                      },
                                                      attrs: {
                                                        disabled:
                                                          !condition.matchRule,
                                                        filterable: "",
                                                      },
                                                      model: {
                                                        value:
                                                          condition.columnValue,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            condition,
                                                            "columnValue",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "condition.columnValue",
                                                      },
                                                    },
                                                    _vm._l(
                                                      _vm.getValueList(
                                                        condition.columnType
                                                      ),
                                                      function (f, fIndex) {
                                                        return _c("el-option", {
                                                          key: fIndex,
                                                          attrs: {
                                                            label: f.label,
                                                            value: f.value,
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _c("el-input", {
                                                    staticStyle: {
                                                      "max-width": "400px",
                                                      "min-width": "280px",
                                                    },
                                                    attrs: {
                                                      disabled:
                                                        !condition.matchRule,
                                                    },
                                                    model: {
                                                      value:
                                                        condition.columnValue,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          condition,
                                                          "columnValue",
                                                          typeof $$v ===
                                                            "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                        )
                                                      },
                                                      expression:
                                                        "condition.columnValue",
                                                    },
                                                  }),
                                            ],
                                            1
                                          ),
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  item.paypalWarningItemList
                                                    .length != 1,
                                                expression:
                                                  "item.paypalWarningItemList.length != 1",
                                              },
                                            ],
                                            staticClass:
                                              "iconfont icona-19yichu",
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeRule(
                                                  index,
                                                  cIndex
                                                )
                                              },
                                            },
                                          }),
                                          _c("i", {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value:
                                                  item.paypalWarningItemList
                                                    .length ==
                                                  cIndex + 1,
                                                expression:
                                                  "item.paypalWarningItemList.length == cIndex + 1",
                                              },
                                            ],
                                            staticClass:
                                              "iconfont icona-20tianjia",
                                            on: {
                                              click: function ($event) {
                                                return _vm.addRule(index)
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  }
                                ),
                              ],
                              2
                            ),
                          ]),
                        ]
                      )
                    }),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text" },
                        on: { click: _vm.addCondition },
                      },
                      [
                        _c("i", {
                          staticClass: "iconfont-el icon-a-12tianjia2",
                        }),
                        _vm._v(" 添加条件 "),
                      ]
                    ),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "warning-notice" },
              [
                _c("div", { staticClass: "notice-title" }, [
                  _vm._v("预警通知"),
                ]),
                _c("div", { staticClass: "notice-tip" }, [
                  _vm._v("推送对象：全部含「PayPal风控中心」查看权限的用户"),
                ]),
                _c(
                  "el-checkbox-group",
                  {
                    model: {
                      value: _vm.form.pushTypes,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "pushTypes", $$v)
                      },
                      expression: "form.pushTypes",
                    },
                  },
                  [
                    _c("el-checkbox", { attrs: { label: 1 } }, [
                      _vm._v("系统消息"),
                    ]),
                    _c("el-checkbox", { attrs: { label: 2 } }, [
                      _vm._v("微信公众号提醒"),
                    ]),
                    _c("el-tooltip", { attrs: { placement: "top" } }, [
                      _c(
                        "span",
                        { attrs: { slot: "content" }, slot: "content" },
                        [
                          _vm._v(
                            " 公众号接收预警信息需关注并绑定shoplus微信公众号，请使用微信关注“超店Shoplus”并绑定您的账号 "
                          ),
                        ]
                      ),
                      _c("i", {
                        staticClass: "iconquestion-circle-o iconfont",
                        staticStyle: {
                          "font-size": "14px",
                          "margin-left": "6px",
                        },
                      }),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "div",
        { staticClass: "hanlde-footer" },
        [
          _c(
            "el-button",
            { staticStyle: { "text-align": "end" }, on: { click: _vm.reset } },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::reset")) + " ")]
          ),
          _c(
            "el-button",
            {
              staticStyle: { "margin-right": "16px" },
              attrs: { type: "primary" },
              on: { click: _vm.sumbit },
            },
            [_vm._v(" " + _vm._s(_vm.$t("system::common::btn::save")) + " ")]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }